import { SidebarApp } from '~/sidebar/sidebarApp.enum';

export const isSidebarApp = (value?: SidebarApp | string): value is SidebarApp =>
  Object.values(SidebarApp).includes(value as SidebarApp);
